import { atom } from 'recoil';
import { ColumnV2 } from '../types';

const initialData: ColumnV2[] = [];

export const WorkflowAtom = atom({
  key: 'workflow-data',
  default: initialData as ColumnV2[],
});
